module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyOS42Ij48cGF0aCBmaWxsPSIjYTMzYzUzIiBkPSJNMjMuNiAwYy0zLjQgMC02LjMgMi43LTcuNiA1LjZDMTQuNyAyLjcgMTEuOCAwIDguNCAwIDMuOCAwIDAgMy44IDAgOC40YzAgOS40IDkuNSAxMS45IDE2IDIxLjIgNi4xLTkuMyAxNi0xMi4xIDE2LTIxLjJDMzIgMy44IDI4LjIgMCAyMy42IDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ../src/images/heart.svg
// module id = 615
// module chunks = 0